<app-header></app-header>
<header class="slidermain menu-page text-white login-page">
    <img src="assets/img/productb1.jpg" alt="news" class="w-100">
  <div class="container-fluid">
     <div class="mask-content-v-center text-left log-card">

        <div class="col-md-4 mx-auto">
         
                <div class="login-box"> 
                    <div class="card-body login-card">
                        <h5 class="card-title">{{ 'login.f_password' | translate }}</h5>
                          <div class="form-signin">
                            <div class="form-group">
                                <label for="">{{ 'login.en_email' | translate }}</label> 
                                <input type="text" id="phone" name="phone" class="form-control" placeholder="" required #phone>
                            </div>
                        <button (click)="getEmail(phone.value)"  class="btn btn-lg btn-primary orderonline"><i class="fas fa-sign-in-alt"></i> {{ 'login.submit' | translate }} 
                            <span *ngIf="isLoading">
                                <i class="fas fa-circle-notch fa-spin"></i>
                            </span>
                        </button>
                        </div>
                        <p style="color: #f00;" *ngIf="errMsg !=''">
                           <span *ngIf="showLang =='en' ">{{errMsg}}</span> 
                        </p>
                        <p style="color: #f00;" *ngIf="errMsg !=''">
                            <span *ngIf="showLang =='ar' ">{{errMsg_ar}}</span>
                        </p>
                    </div>
                </div>
            
 </div>
</div>
</div>
</header>
